import { Form } from "reactstrap";
import { FormInput } from "components/Form/FormInput";
import { FormSelect } from "components/Form/FormSelect";

Form.Input = FormInput;
Form.Select = FormSelect;

export { Form };